import { useQuery } from "@tanstack/react-query";
import { RestEndpoints } from "../../../api/endpoints";
import { PomQueryKeys } from "../../pom-query-keys";
import getInstance from "../../../utils/rest";

const getReportingDraftNos = async (contractNo: string): Promise<number[]> => {
  const result = await getInstance().get<number[]>(`${RestEndpoints.PomReportingDrafts}/${contractNo}`);
  return result.data;
};

export const useGetReportingDraftNosQuery = (contractNo: string | undefined) => {
  return useQuery({
    queryKey: [PomQueryKeys.GetReportingDraftNos, contractNo],
    queryFn: () => getReportingDraftNos(contractNo as string),
    enabled: contractNo !== undefined,
  });
};
